module.exports = __webpack_public_path__ + "img/Edufy.9e7555b8.png";